module.exports = __webpack_public_path__ + "media/images/application/icons/icon-tick-list-dd0bc3be42fc1a669eea3211b809df0d.svg";